import { Component, Input, OnInit } from '@angular/core';
import { ExportStammperson } from '../../../../../core/batch-auftrag-api';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { MetaDisablerDirective } from '../../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../../shared/directives/meta-validator.directive';
import { CapFormControlComponent } from '../../../../../shared/form-control/form-control.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-select-stammperson',
  templateUrl: './select-stammperson.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: NgForm
    }
  ],
  imports: [FormsModule, MetaDisablerDirective, MetaValidatorDirective, CapFormControlComponent, TranslatePipe]
})
export class SelectStammpersonComponent implements OnInit {
  @Input()
  model: ExportStammperson;

  @Input()
  disabled: boolean;

  constructor() {}

  ngOnInit() {}

  disableSubChoices() {
    if (this.model.personstammVollstaendig == false) {
      this.model.aciIroleNr = false;
      this.model.personAdresse = false;
    }
  }
}
